import { render, staticRenderFns } from "./DeviceDict.vue?vue&type=template&id=8d240ac4&scoped=true"
import script from "./DeviceDict.vue?vue&type=script&lang=js"
export * from "./DeviceDict.vue?vue&type=script&lang=js"
import style0 from "./DeviceDict.vue?vue&type=style&index=0&id=8d240ac4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d240ac4",
  null
  
)

export default component.exports